export const stateName = 'bumps';
export const VALUE_PROPOSITION_SHOWN_COOKIE_NAME = 'push_up_value_proposition_shown';